import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-part',
    templateUrl: './question-damage-image-part.component.html',
    styleUrls: ['./question-damage-image-part.component.scss'],
    standalone: false
})
export class QuestionDamageImagePartComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
